export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  default_category_view: 'list',
  assets_domains: {
    item_thumbnail: 'thumb-cc.s3.envato.com',
    item_image: 'image-cc.s3.envato.com'
  },
  feeds_categories: [
    '/category/javascript',
    '/category/php-scripts',
    '/category/net',
    '/category/wordpress',
    '/category/plugins',
    '/category/css',
    '/category/html5',
    '/category/mobile',
    '/category/apps',
    '/category/skins',
    '/category/edge-animate-templates'
  ]
}



// WEBPACK FOOTER //
// ./config/sites/codecanyon.js